import CapsuleElement from "components/dashboard/KnowledgeBase/common/Capsule/CapsuleElement/CapsuleElement";
import { branchOptionActionTypes } from "components/dashboard/TrainSAM/SAM/Conversations/enums";
import { Button } from "components/ui";
import { DeleteIconButton } from "components/ui/Button/IconButton/IconButton";
import { branchOptionActions, branchOptionTypeList } from "./enum";
import { convoBreakerActionBranchOptionTypeValues } from "components/dashboard/ServiceModule/ChatSettings/ConversationBreakers/enums";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { DEPENDENCY_BRANCH_UPDATE_PERMISSION } from "components/dashboard/TrainSAM/Dependency/permissions";
import {
    CAPSULE_DELETE_PERMISSION,
    CAPSULE_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/permissions";
import {
    isPostFormBranchCollection,
    POST_FORM_WORKFLOW_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/PostForms/permissions";
import {
    CONVERSATION_BREAKER_UPDATE_PERMISSION,
} from "components/dashboard/ServiceModule/permissions";
import {
    ISSUE_CONVERSATION_DELETE_PERMISSION,
    ISSUE_CONVERSATION_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import { baseResources, baseResourceActions } from "routes/enum";
import "./BranchOption.scss";
import BranchOptionSchedule from "./BranchOptionSchedule/BranchOptionSchedule";
import { useSelector } from "react-redux";

const { AGENTS_INBOX_CONVERSATION_BREAKER } = baseResources;

const { UPDATE } = baseResourceActions;
const { EDIT_BRANCH_OPTION, EDIT_CONVERSATION_BREAKER_OPTION } =
    branchOptionActions;

const BranchOption = ({
    option,
    handleSelectOption,
    toggleEditModal,
    toggleDeleteModal,
    updateModalActionType,
    isConversationBreakerView,
    isAgentGuideView,
    branchCollectionType,
}) => {
    const {
        guideFlowOptionActionType,
        guideFlowOptionCapsuleClassId,
        guideFlowOptionCapsuleEntryId,
        guideFlowOptionLabel,
        guideFlowOptionType,
        guideFlowOptionValue,
    } = option || {};

    const {
        branchOptionLabel,
        branchOptionCapsuleClass,
        branchOptionCapsuleEntryId,
        branchOptionActionType,
        branchOptionType,
        isScheduled,
        scheduleDuration,
        branchOptionValue,
    } = option || {};

    // check if this option is linked to another option or has an action
    const isOptionInvalid = isAgentGuideView
        ? guideFlowOptionValue === null && guideFlowOptionActionType === null
        : ((branchOptionValue === null && branchOptionActionType === null) || (branchOptionActionType === "FORWARD_AGENT" && branchOptionCapsuleEntryId === null));

    const branchOptionUpdatePermissions = isConversationBreakerView
        ? CONVERSATION_BREAKER_UPDATE_PERMISSION
        : isPostFormBranchCollection(branchCollectionType)
        ? POST_FORM_WORKFLOW_UPDATE_PERMISSION
        : [
              ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
              ...CAPSULE_UPDATE_PERMISSION,
              `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
              ...ISSUE_CONVERSATION_UPDATE_PERMISSION,
          ];

    const branchOptionDeletePermissions = isConversationBreakerView
        ? CONVERSATION_BREAKER_UPDATE_PERMISSION
        : isPostFormBranchCollection(branchCollectionType)
        ? POST_FORM_WORKFLOW_UPDATE_PERMISSION
        : [
              ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
              ...CAPSULE_DELETE_PERMISSION,
              `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
              ...ISSUE_CONVERSATION_DELETE_PERMISSION,
          ];

    const { capsuleClasses } = useSelector((state) => state.capsule);

    const guideCapsuleClass = capsuleClasses?.find?.(
        ({ capsuleClassId }) => capsuleClassId === guideFlowOptionCapsuleClassId
    );
    return (
        <>
            <div
                className={`branch__option ${
                    isOptionInvalid ? "invalid" : ""
                }`}>
                <div className='row align-items-center'>
                    <div className='col-md-8'>
                        <h6>{branchOptionLabel || guideFlowOptionLabel}</h6>
                    </div>
                    <div className='col-md-4'>
                        <ComponentAccessControl
                            baseResources={branchOptionUpdatePermissions}>
                            <Button
                                text='Edit Option'
                                classType='plain'
                                otherClass={"branch__option__button"}
                                onClick={() => {
                                    updateModalActionType(
                                        isConversationBreakerView
                                            ? EDIT_CONVERSATION_BREAKER_OPTION
                                            : EDIT_BRANCH_OPTION
                                    );
                                    toggleEditModal(true);
                                    handleSelectOption(option);
                                }}
                            />
                        </ComponentAccessControl>
                    </div>
                </div>
                <div>
                    <p className='connections'>Connections:</p>
                    {branchOptionCapsuleEntryId ||
                    guideFlowOptionCapsuleEntryId ? (
                        <div>
                            <CapsuleElement
                                capsule={
                                    branchOptionCapsuleClass ||
                                    guideCapsuleClass
                                }
                                capsuleEntryId={
                                    branchOptionCapsuleEntryId ||
                                    guideFlowOptionCapsuleEntryId
                                }
                                useCapsuleStyles={true}
                                hideEditAction={true}
                            />
                        </div>
                    ) : (
                        <div className='text-dark'>NONE</div>
                    )}

                    {(branchOptionType || guideFlowOptionType) && (
                        <p className='connections'>
                            Connected to{" "}
                            {" " +
                                branchOptionTypeList[
                                    isAgentGuideView
                                        ? guideFlowOptionType
                                        : branchOptionType
                                ]}
                        </p>
                    )}

                    {isScheduled && (
                        <BranchOptionSchedule
                            scheduleDuration={scheduleDuration}
                        />
                    )}

                    <div className='row align-items-center'>
                        <div className='col-md-6'>
                            {(branchOptionActionType ||
                                guideFlowOptionActionType) && (
                                <div className='blue__tag'>
                                    <div className='circle'></div>
                                    <span>
                                        {isConversationBreakerView
                                            ? convoBreakerActionBranchOptionTypeValues[
                                                  branchOptionActionType
                                              ]
                                            : branchOptionActionTypes[
                                                  isAgentGuideView
                                                      ? guideFlowOptionActionType
                                                      : branchOptionActionType
                                              ]}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className='col-md-2 d-flex justify-content-end ms-auto'>
                            <ComponentAccessControl
                                baseResources={branchOptionDeletePermissions}>
                                {" "}
                                <DeleteIconButton
                                    onClick={() => {
                                        toggleDeleteModal(true);
                                        handleSelectOption(option);
                                    }}
                                />
                            </ComponentAccessControl>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BranchOption;
